var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('router-view'),_c('plugin-com',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"de-theme",attrs:{"component-name":"ThemeSetting"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }